import { css, html } from 'lit';
import { property } from 'lit/decorators.js';

import { BaseElement, customElement } from '../../components/base-element';

import '../../components/buttons/icon-button/icon-button.wc';

const DEFAULT_HELP_URL =
  'https://pypestream.atlassian.net/servicedesk/customer/article/669352070';

@customElement('ps-universal-nav-help')
export class UniversalNavHelpWC extends BaseElement {
  static styles = css`
    :host {
      display: contents;
    }
  `;

  @property({ type: String }) url: string = DEFAULT_HELP_URL;

  private handleClick(): void {
    window.open(this.url, '_blank');
  }

  render() {
    return html`
      <ps-icon-button
        name="help"
        @click=${() => this.handleClick()}
      ></ps-icon-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'ps-universal-nav-help': UniversalNavHelpWC;
  }
  enum PSElementTagNameMap {
    'ps-universal-nav-help' = 'ps-universal-nav-help',
  }
}
